import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeNext", "tourKey", "stepKey", "children", "useInStepKey", "navigationCallbackPath"];
import { useContext, useRef } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import TourContext from '../contexts/TourContext';
import getNextStep from '../lib/getNextStep';
import { DONE } from '../constants/TourStates';
import handleCallback from '../lib/handleCallback';
import { jsx as _jsx } from "react/jsx-runtime";
const renderDefaultText = tour => {
  if (getNextStep(tour) === DONE) {
    return I18n.text('shepherd-react.finish');
  }
  return I18n.text('shepherd-react.next');
};
const isTourStepMatched = (tourContext, stepKey) => {
  // If stepKey is empty, consider as matched
  if (!stepKey) {
    return true;
  }
  const currentStepKey = tourContext.getStep();
  return currentStepKey === stepKey;
};
const UITourNextButton = props => {
  const {
    tour
  } = useContext(TourContext);
  const {
      beforeNext = emptyFunction,
      tourKey,
      stepKey,
      children = renderDefaultText(tour),
      useInStepKey,
      navigationCallbackPath
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    getTour,
    getStep
  } = tour;
  const isHandlingClick = useRef(false);
  const handleClick = event => {
    // Skip click handler if:
    //   1. tour handler is executing
    //   2. Or current tour step are not matched with given props
    if (isHandlingClick.current || !isTourStepMatched(tour, useInStepKey)) {
      return null;
    }
    isHandlingClick.current = true;
    if (props.onClick) {
      props.onClick(event);
    }
    try {
      return handleCallback(beforeNext, () => {
        tour.next(stepKey);
        isHandlingClick.current = false;
        if (navigationCallbackPath && tour.navigationCallback) {
          tour.navigationCallback(navigationCallbackPath);
        }
      }, {
        tourKey: tourKey || getTour(),
        stepKey: stepKey || getStep()
      });
    } catch (error) {
      isHandlingClick.current = false;
      throw error;
    }
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};
export default UITourNextButton;